import { createContext } from 'react';

const CoreBootMainContext = createContext({});

export default CoreBootMainContext;
